import { render, staticRenderFns } from "./TablaSectoresComponent.vue?vue&type=template&id=602f2e9b"
import script from "./TablaSectoresComponent.vue?vue&type=script&lang=js"
export * from "./TablaSectoresComponent.vue?vue&type=script&lang=js"
import style0 from "./TablaSectoresComponent.vue?vue&type=style&index=0&id=602f2e9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports